export const LOCAL_STORAGE_KEYS = {
  BEDROCK_IS_LOCAL: "bedrock-is-local",
  CHALLENGE_DATETIME: "challenge_datetime",
  TRACKING_SESSION: "trackingSession",
  VERSION_CHECKER: "versionChecker",
} as const;

export function getObjectLocalStorage<T extends Record<string, any>>(
  key: string,
): T | undefined {
  try {
    const data = localStorage.getItem(key);

    if (!data) return undefined;

    return JSON.parse(data) as T;
  } catch (err) {
    console.error(err);
  }
}

export function setObjectLocalStorage<T extends Record<string, any>>(
  key: string,
  value: T,
) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
    console.error(`Failed to set localStorage key '${key}':`, err);
  }
}

export function getObjectOrDefaultLocalStorage<T extends Record<string, any>>(
  key: string,
  defaultValue: T,
): T {
  let storedValue = localStorage.getItem(key);

  if (!storedValue) {
    console.info(
      `No value for key '${key}' from localStorage. Setting default value`,
    );
    storedValue = JSON.stringify(defaultValue);
    try {
      localStorage.setItem(key, storedValue);
    } catch (err) {
      console.error(`Failed to set localStorage key '${key}':`, err);
    }
  } else {
    try {
      return JSON.parse(storedValue) as T;
    } catch (_error) {
      console.error(`Error parsing value for key '${key}' from localStorage.`);
    }
  }

  return defaultValue;
}
